import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  menuItems = [
    { name: "Candidate Test Schedule", target: "cand-test-schedule", icon:"far fa-calendar-alt" },
    { name: "Exam Status", target: "exam-status" , icon:"fas fa-file-alt fa-1x", enabled:true },
    { name: "Question Analysis", target: "ques-analysis", icon:"fa fa-question-circle" },
    { name: "Candidate Response Log", target: "cand-res-log", icon:"fas fa-portrait" },
    { name: "Candidate Exam Response", target: "cand-exam-res",icon:"far fa-list-alt"},
    { name: "Score", target: "score" ,  enabled:true },
      { name: "Devices", target: "devices" ,  enabled:true },
    { name: "Percentage Wise Score", target: "perce-wise-score",icon: "fa fa-percent" },
    { name: "Topic Wise Score", target: "topic-wise-score", icon: "fa fa-star-o"},
    { name: "View Question Paper", target: "view-ques-paper", icon: "fas fa-question-square" },
    { name: "Bulk Download", target: "bulk-download", icon: "fa fa-download" },
    { name: "Marksheet", target: "marksheet", icon:"fa fa-ballot" },
    { name: "Bulk Generation", target: "bulk-generation" },
    { name: "Bulk Audit Trail", target: "bulk-audit-trail" },
 { name: "Bulk Candidate Response Log", target: "bulk-cand-res-log" },
 

    { name: "Question Analysis", target: "ques-analysis", icon: "fa fa-search"},
    { name: "Day End", target: "day-end", icon:"fas fa-calendar" },
    { name: "Exam-Duration", target: "exam-duration" ,icon: "fa fa-user-clock"},
    { name: "Answer-Sheet", target: "answer-sheet",icon: "fas fa-file-alt" },
    { name: "Idle-Candidate", target: "idle-candidate",icon:"far fa-user" },

  ];

  constructor(private router: Router) { }

  ngOnInit() { }
  menuClick(m) {
    if (!m.enabled){
      return;
    }
    this.router.navigate(["reports/" + m.target]);
  }
}
